<script setup lang="ts">
const { type = "warning" } = defineProps<{ type?: "warning" | "danger" }>();
</script>

<template>
    <div class="notification" :class="`notification_${type}`" role="alert">
        <slot />
    </div>
</template>

<style scoped>
.notification {
    padding: 8px 10px;
    border-radius: 6px;
    font-size: calc(var(--custom-font-size) * 1.143);
    font-weight: 700;
    line-height: 1.25;
    text-align: center;
}

.notification_warning {
    background-color: #fff8eb;
    color: #f79009;
}

.notification_danger {
    background-color: #fef2f4;
    color: var(--color-error);
}
</style>
